import Vue from 'vue'
import Vant, { Dialog, Toast } from 'vant'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import storage from '@/utils/storage'
// import cnzzAnalyst from 'vue-cnzz-analytics'
import { checkAccount, newAccount } from '@/api/api'
import { JWTdecode, newSign, JWTverify } from '@/utils/jwt'
import 'vant/lib/index.less'

const onDebug = process.env.NODE_ENV === 'production' ? false : true
// const onDebug = true

// 百度统计
// var _hmt = _hmt || []
// window._hmt = _hmt
// ;(function () {
//   var hm = document.createElement('script')
//   hm.src = 'https://hm.baidu.com/hm.js?d97ac9845539c67073d6b2a4e1238c29'
//   var s = document.getElementsByTagName('script')[0]
//   s.parentNode.insertBefore(hm, s)
// })()

/*
Vue.use(cnzzAnalyst, {
  router,
  siteIdList: [1281102875]
  // isDebug: true
})
*/

let zjrbCp = document.createElement('script')
zjrbCp.async = 'async'
zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js'
zjrbCp.charset = 'UTF-8'

document.body.appendChild(zjrbCp)

zjrbCp.onload = function () {
  if (CP && typeof CP.ready === 'function') {
    CP.ready({
      debug: onDebug,
      es6Require: false,
      ready: function (client_info) {
        // console.log(client_info);
        // console.log('ready')

        // client_info 为 { client_code: 'web', version: '1.0', detail: ''}  clientInfo 接口返回数据
        main(client_info)
      },
      error: function (error) {
        //error   {code: 4000, msg: res.errMsg, data: res}  res为原生报错 微信的报错也在这处理
        console.log(error)
      }
    })
  }
}

function main(client_info) {
  var clientCode = client_info.client_code
  Vue.use(Vant)

  Vue.prototype.$storage = storage
  Vue.prototype.$axios = axios
  Vue.prototype.$clientCode = clientCode
  Vue.config.productionTip = false

  router.beforeEach((to, from, next) => {
    // if (_hmt) {
    //   if (to.path) {
    //     _hmt.push(['_trackPageview', '/#' + to.fullPath])
    //   }
    // }
    document.title =
      to.meta.title == undefined ? '掌上温岭——直播' : to.meta.title
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      // 判断是哪个平台的，非客户端直接跳转到固定页面，提示在app里打开
      if (clientCode !== 'xsb_iwenling') {
        if (
          to.matched.some(
            (record) =>
              record.meta.onlyInApp !== undefined &&
              record.meta.onlyInApp == false
          )
        ) {
          // console.log(222, to);
          // TODO: 所有链接都转换成可以在app外打开的
          if(to.name == 'detail'){
            next({ path: '/live/outdetail/' + to.params.id })
          }else{
            let newToken = newSign('5bfdec14a61d563565fe2381')
            storage.set('token', newToken)
            next();
          }
        } else {
          next({
            path: '/notinapp',
            query: { redirect: to.fullPath }
          })
        }
      } else {
        CP.isLogin({
          completed: function (data) {
            if (data.is_login !== 1) {
              CP.showLogin({
                completed: function (data) {
                  if (data.is_login == '1') {
                    storage.set('uniqueId', data.unique_id)
                    storage.set('accountId', data.account_id)
                    // 再获取用户在app端的基本信息，传回后台看是否要新增或者更新
                    CP.getCustomerInfo({
                      completed: function (data) {
                        if (data.account_id == '-1') {
                          Dialog.alert({
                            title: '温馨提示',
                            message: '账号异常，请退出账号重新登录'
                          }).then(() => {
                            // on close
                            CP.closePage({
                              completed: function (cdata) {
                                CP.tools.writelog('close_page', cdata)
                              },
                              cpIncompatible: function () {
                                CP.tools.writelog('', '此环境不支持此方法')
                              }
                            })
                          })
                        } else {
                          storage.set('appUser', data)
                          storage.set('accountId', data.account_id)

                          let newToken = newSign(data.account_id)
                          storage.set('token', newToken)

                          // 判断这个account_id的用户是否存在在后台数据库中
                          checkAccount().then((res) => {
                            if (res.code == 1) {
                              storage.set('hasUser', true)
                              let zswlUser = res.data.user

                              let now = new Date()
                              if (
                                !zswlUser.updatetime ||
                                now - zswlUser.updatetime * 1000 >
                                  24 * 60 * 60 * 60
                              ) {
                                newAccount({ appUser: data }).then((re) => {
                                  if (res.code == 1) {
                                    storage.set('zswlUser', re.data.user)
                                    next()
                                  } else {
                                    Toast.fail(res.msg)
                                    setTimeout(function () {
                                      next({
                                        path: '/notfound'
                                      })
                                    }, 2000)
                                  }
                                })
                              } else {
                                storage.set('zswlUser', zswlUser)
                              }
                              next()
                            } else {
                              newAccount({ appUser: data }).then((res) => {
                                if (res.code == 1) {
                                  storage.set('hasUser', true)
                                  let zswlUser = res.data.user
                                  storage.set('zswlUser', zswlUser)
                                  next()
                                } else {
                                  Toast.fail(res.msg)
                                  setTimeout(function () {
                                    next({
                                      path: '/notfound'
                                    })
                                  }, 2000)
                                }
                              })
                            }
                          })
                        }
                      },
                      cpIncompatible: function () {
                        CP.tools.writelog('', '此环境不支持此方法')
                      }
                    })
                  } else {
                    // 跳转到统一的登录页面，有个按钮可以再次发起登录
                    storage.clear()
                    next({
                      path: '/unilogin',
                      query: { redirect: to.fullPath }
                    })
                  }
                },
                cpIncompatible: function () {
                  CP.tools.writelog('', '此环境不支持此方法')
                }
              })
            } else {
              CP.getCustomerInfo({
                completed: function (redata) {
                  if (redata.account_id == '-1') {
                    Dialog.alert({
                      title: '温馨提示',
                      message: '账号异常，请退出账号重新登录'
                    }).then(() => {
                      // on close
                      CP.closePage({
                        completed: function (cdata) {
                          CP.tools.writelog('close_page', cdata)
                        },
                        cpIncompatible: function () {
                          CP.tools.writelog('', '此环境不支持此方法')
                        }
                      })
                    })
                  } else {
                    // 判断是否存在token，解密token后是否跟accountId一样
                    let reFresh = false
                    let token = storage.get('token')
                    if (!token) {
                      reFresh = true
                    } else {
                      let vj = JWTdecode(token)
                      if (vj.data.account_id !== redata.account_id) {
                        reFresh = true
                      }

                      // 判断是否过期
                      let isTokenExp = JWTverify(token)
                      if(isTokenExp == false){
                        reFresh = true
                      }
                    }

                    if (reFresh) {
                      // create token and save to storage
                      let newToken = newSign(redata.account_id)
                      storage.set('token', newToken)
                      storage.set('hasUser', false)
                    }

                    storage.set('appUser', redata)
                    storage.set('accountId', redata.account_id)

                    let hasUser = storage.get('hasUser')
                    // storage.set('zswlUser', undefined);
                    let zswlUser = storage.get('zswlUser')
                    if (!hasUser || !zswlUser) {
                      // 判断这个account_id的用户是否存在在后台数据库中
                      checkAccount().then((res) => {
                        if (res.code == 1) {
                          if (res.data.exist) {
                            storage.set('hasUser', true)
                            let zswlUser = res.data.user
                            let now = new Date()
                            if (
                              !zswlUser.updatetime ||
                              now - zswlUser.updatetime * 1000 >
                                24 * 60 * 60 * 60
                            ) {
                              newAccount({ appUser: redata }).then((re) => {
                                if (res.code == 1) {
                                  storage.set('zswlUser', re.data.user)
                                  next()
                                } else {
                                  Toast.fail(res.msg)
                                  setTimeout(function () {
                                    next({
                                      path: '/notfound'
                                    })
                                  }, 2000)
                                }
                              })
                            } else {
                              storage.set('zswlUser', zswlUser)
                            }
                            next()
                          } else {
                            newAccount({ appUser: redata }).then((res) => {
                              if (res.code == 1) {
                                storage.set('hasUser', true)
                                let zswlUser = res.data.user
                                storage.set('zswlUser', zswlUser)
                                next()
                              } else {
                                Toast.fail(res.msg)
                                setTimeout(function () {
                                  next({
                                    path: '/notfound'
                                  })
                                }, 2000)
                              }
                            })
                          }
                        } else {
                          Toast.fail(res.msg)
                          setTimeout(function () {
                            next({
                              path: '/notfound'
                            })
                          }, 2000)
                        }
                      })
                    } else {
                      let now = new Date()
                      if (
                        !zswlUser.updatetime ||
                        now - zswlUser.updatetime * 1000 > 24 * 60 * 60 * 60
                      ) {
                        newAccount({ appUser: redata }).then((re) => {
                          if (res.code == 1) {
                            storage.set('zswlUser', re.data.user)
                            next()
                          } else {
                            Toast.fail(res.msg)
                            setTimeout(function () {
                              next({
                                path: '/notfound'
                              })
                            }, 2000)
                          }
                        })
                      }
                      next()
                    }
                  }
                },
                cpIncompatible: function () {
                  CP.tools.writelog('', '此环境不支持此方法')
                }
              })
            }
          },
          cpIncompatible: function () {
            console.log('此环境不支持此方法')
          }
        })
      }
    } else {
      // console.log('3333', to);
      if (clientCode == 'xsb_iwenling') {
        // TODO: 这一块做一个映射，自动跳
        if (to.name == 'outdetail') {
          next({ path: '/live/detail/' + to.params.id })
        }
      }
      // console.log(to)
      next() // 确保一定要调用 next()
    }
  })

  new Vue({
    router,
    render: (h) => h(App)
  }).$mount('#app')
}
